import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./Switch.scss";

const Switch = props => {
	const { className, onClick, on, disabled, label, dataTestId } = props;

	const handleKeyPress = event => {
		const { key } = event;
		if (key === "Enter" && !disabled) onClick(event);
	};

	return (
		<div
			role="button"
			tabIndex="0"
			className="switch-label"
			onClick={disabled ? undefined : onClick}
			onKeyPress={handleKeyPress}
			data-test-id={dataTestId}
		>
			<div className={classNames("toggle-switch", className, { disabled, on })}>
				<div className="indicator" />
			</div>
			<span className="switch-text">{label}</span>
		</div>
	);
};

Switch.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	onClick: PropTypes.func,
	on: PropTypes.bool,
	disabled: PropTypes.bool,
	dataTestId: PropTypes.string
};

Switch.defaultProps = {
	className: "",
	label: "",
	onClick: () => {},
	on: false,
	disabled: false,
	dataTestId: undefined
};

export default Switch;
